var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStyle5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4029 5H22.7999C23.4153 5 23.9226 5.46881 23.9919 6.07279L24 6.21442V14.7153C24 15.386 23.4627 15.9298 22.7999 15.9298C22.1844 15.9298 21.6771 15.4609 21.6078 14.857L21.5997 14.7153L21.5988 9.14602L12.8473 18.0029C12.4149 18.4404 11.7347 18.4743 11.2639 18.1045L11.1508 18.0036L8.39529 15.2202L2.04889 21.6442C1.58028 22.1185 0.820401 22.1186 0.351646 21.6444C-0.0810514 21.2067 -0.114439 20.5179 0.251556 20.0414L0.351375 19.927L7.54566 12.6447C7.97801 12.2071 8.65834 12.1731 9.12922 12.543L9.2423 12.6439L11.9979 15.4275L19.9006 7.42883H14.4029C13.7874 7.42883 13.2801 6.96002 13.2108 6.35604L13.2027 6.21442C13.2027 5.59162 13.666 5.07832 14.2629 5.00817L14.4029 5H22.7999H14.4029Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStyle5);
export default __webpack_public_path__ + "static/media/icon_style_5.2e019f03.svg";
export { ForwardRef as ReactComponent };